import * as React from 'react'
import { Form, Field, InjectedFormProps } from 'redux-form'
import { Input } from 'components/Input/Input'
import SelectPretty from 'components/Input/SelectPretty'
import Button from 'components/Button'
import cn from 'classnames'
import * as sMarg from 'styles/modules/margins.scss'
import { Row, Col } from 'components/Layout'
import * as sLay from 'styles/modules/layout.scss'
import {
  IExtensionFormData,
  IPhoneSystemExtensionEditFormProps,
} from './PhoneSystemExtensionEditForm.container'
import {
  GetPhoneSystemServiceDocument,
  useCreatePhoneSystemExtensionMutation,
  useUpdatePhoneSystemExtensionMutation,
} from 'src/generated/graphql'
import { vNotEmpty } from 'components/Input/Input.validations'

export type IPhoneSystemExtensionEditFormComponentProps = IPhoneSystemExtensionEditFormProps &
  InjectedFormProps<IExtensionFormData>

const vNumber = value => {
  if (value && value.length > 3) {
    return 'Only up to 3 digits'
  }

  if (value && !/^\d+$/.test(value)) {
    return 'Only digits allowed'
  }

  return undefined
}

export const PhoneSystemExtensionEditFormComponent = (
  props: IPhoneSystemExtensionEditFormComponentProps
) => {
  const { submitting, handleSubmit, onAfterSubmit, didNumbers, isAdmin } = props
  const [updatePhoneSystemExtension] = useUpdatePhoneSystemExtensionMutation()
  const [createPhoneSystemExtension] = useCreatePhoneSystemExtensionMutation()

  const displayNumberOptions = ([] as { name: string; value: string }[]).concat(
    [
      {
        name: 'No Override',
        value: '',
      },
    ],
    didNumbers?.map(number => ({
      name: `${number.number} (${number.customerReference})`,
      value: number.number,
    })) || []
  )

  return (
    <Form
      onSubmit={handleSubmit(async variables => {
        if (variables.extensionId) {
          await updatePhoneSystemExtension({ variables })
        } else {
          await createPhoneSystemExtension({
            variables,
            refetchQueries: [
              {
                query: GetPhoneSystemServiceDocument,
                variables: { id: props.initialValues.phoneSystemId },
              },
            ],
            awaitRefetchQueries: true,
          })
        }
        onAfterSubmit()
      })}
    >
      <Row className={cn(sLay['layout-row'], 'sm')}>
        <Col className={cn(sLay['flex-50'], 'sm')}>
          <Field name="name" label="Name" component={Input} validate={[vNotEmpty]} />
        </Col>
        <Col className={cn(sLay['flex-50'], 'sm')}>
          <Field
            name="number"
            label="Number"
            component={Input}
            disabled={!(!props.initialValues.extensionId || isAdmin)}
            validate={[vNotEmpty, vNumber]}
          />
        </Col>
      </Row>

      <Field
        name="displayNumber"
        label="Display Number"
        component={SelectPretty}
        options={displayNumberOptions}
      />

      <div className={cn(sLay['layout-column'], sLay['layout-align-center-center'], sMarg.mt30)}>
        <Button color="tertiary" loading={submitting} disabled={submitting} type="submit">
          {!!props.initialValues.extensionId ? 'Update' : 'Create'}
        </Button>
      </div>
    </Form>
  )
}



// WEBPACK FOOTER //
// src/features/PhoneSystem/PhoneSystemExtensionEditForm/PhoneSystemExtensionEditForm.tsx